module.exports = __webpack_public_path__ + "img/plane.66d0a7d8.svg";